import { Localized } from "@fluent/react";
import { LinearProgress } from "@mui/material";
import { useEffect } from "react";
import { getAlarmGroups, removeAlarmGroupUser } from "../../store/thunk/alarmGroup";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { RejectionReason } from "../../store/slices/alarmGroup";
import AlarmGroupUI from "../ui/AlarmGroupUI";

export default function AlarmGroups() {
	const dispatch = useAppDispatch();
	const alarmGroup = useAppSelector(state => state.alarmGroup);

	useEffect(() => {
		// If we don't have data yet and not attempt was made to request it,
		// dispatch a request to get the data of the alarm groups.
		if (alarmGroup.kind === "initializing"
			&& !alarmGroup.pending && alarmGroup.rejectionReason === undefined) {
			dispatch(getAlarmGroups());
		}
	}, [dispatch, alarmGroup]);

	function removeUserFromAlarmGroup(alarmGroupID: string, userID: string) {
		console.log('removed user', userID, 'from alarm group', alarmGroupID);
		dispatch(removeAlarmGroupUser(alarmGroupID, userID));
	}

	switch (alarmGroup.kind) {
		case 'initializing':
			if (alarmGroup.rejectionReason !== undefined) {
				switch (alarmGroup.rejectionReason) {
					case RejectionReason.Network:
						return <Localized id="loading-failed-network" />;
					case RejectionReason.Bug:
						return <Localized id="loading-failed-bug" />;
				}
			}

			return <LinearProgress sx={{ height: "8px" }} />;
		case 'ready':
			return <>{alarmGroup.alarmGroups.map(alarmGroup =>
				<AlarmGroupUI
					key={alarmGroup.alarm_group_id}
					name={alarmGroup.template.title}
					members={alarmGroup.users}
					membersHealth={[]}
					organizationID={alarmGroup.organization_id}
					alarmGroupID={alarmGroup.alarm_group_id}
					removeUserFromAlarmGroup={
						(userID) => removeUserFromAlarmGroup(alarmGroup.alarm_group_id, userID)
					}
				/>)
			}</>;
	}
}
